import React from "react";

const TableauIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_554)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.2276 20.6786H20.7585V26.6666H18.6029V20.6786H13.0939V18.6028H18.6029V12.6147H20.7585V18.6028H26.2276V20.6786Z",
  fill: "#E8762C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2495 28.0639H10.3393V22.6747H8.50296V28.0639H3.51294V29.6607H8.50296V34.9701H10.3393V29.6607H15.2495V28.0639Z",
  fill: "#C72035"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.2076 9.18164H31.2575V3.83234H29.4212V9.18164H24.511V10.8583H29.4212V16.1677H31.2575V10.8583H36.2076V9.18164Z",
  fill: "#59879B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8722 33.8922H20.5589V30.1796H18.9621V33.8922H15.5688V35.3293H18.9621V39.1217H20.5589V35.3293H23.8722V33.8922Z",
  fill: "#5B6591"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2096 9.14172H10.2195V3.83234H8.42313V9.14172H3.43311V10.7385H8.42313V16.1677H10.2195V10.7385H15.2096V9.14172Z",
  fill: "#EB912C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 18.9221H36.6867V15.2096H35.0499V18.9221H31.6967V20.3593H35.0499V24.0718H36.6867V20.3593H40V18.9221Z",
  fill: "#5B6591"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.8883 28.0639H30.9781V22.6747H29.1418V28.0639H24.1917V29.6607H29.1418V34.9701H30.9781V29.6607H35.8883V28.0639Z",
  fill: "#1F447E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6327 3.71258H20.3193V0H19.1217V3.71258H15.8083V4.83034H19.1217V8.46307H20.3193V4.83034H23.6327V3.71258Z",
  fill: "#7099A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.82435 19.0818H4.51098V15.4491H3.31337V19.0818H0V20.1996H3.31337V23.8323H4.51098V20.1996H7.82435V19.0818Z",
  fill: "#7099A6"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_554"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TableauIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;